// src/utils/emailEscape.js
//
// s9preview-7a3d2f40 — S9b (S4 follow-up d). Web mirror of functions/utils/emailEscape.js, the ONE
// escapeHtml every server email builder uses. The email-template preview (EmailTemplatesSettings)
// escapes exactly what the server escapes, so the preview shows what the customer will receive —
// a template line containing "<b>" shows as the literal text, as in the sent email.
// Keep the two copies identical (emailEscape.test.js compares them).

const ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;',
};

export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[&<>"'`]/g, (c) => ESCAPES[c]);
}
